import { Link } from "@tanstack/solid-router";

export function SiteFooter() {
  return (
    <footer class="border-t border-white/5 bg-[#050308]">
      <div class="mx-auto flex w-full max-w-7xl flex-col gap-4 px-6 py-8 text-sm text-white/60 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p>{new Date().getFullYear()} ActShark. All rights reserved.</p>

        <nav class="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/terms" class="transition-colors hover:text-white">
            Terms
          </Link>
          <Link to="/privacy" class="transition-colors hover:text-white">
            Privacy
          </Link>
          <Link to="/data-deletion" class="transition-colors hover:text-white">
            Data Deletion
          </Link>
          <Link to="/contact" class="transition-colors hover:text-white">
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
